import { Alert, Button } from 'antd';

/**
 * The first sentence of a lock refusal: the API's 409 `item_locked` says
 * why the record is closed and then what can be done ("A manager can unlock
 * it, or you can add a correction."). The notice says the second part itself,
 * by who is reading, so it keeps only the first.
 */
export function lockSentence(text) {
	const value = typeof text === 'string' ? text.trim() : '';
	if (!value) return 'This record is locked.';
	const match = value.match(/^.*?\.(?=\s|$)/);
	return match ? match[0] : value;
}

/**
 * A locked record, said above the item form's fields before anyone tries to
 * save (KPR-155; utils/recordPolicy: a form that looks editable and then
 * refuses is worse than one that says plainly that this record is closed).
 *
 * `reason` is the lock in the API's words. What can be done next depends on
 * who is reading: a manager can unlock it, anyone who can edit it can add a
 * correction (not to a record already corrected), and a person who cannot
 * unlock is told who can. The buttons open the item menu's own Unlock and
 * Correct dialogs.
 */
export default function RecordLockNotice({ reason, canManage = false, canCorrect = true, onUnlock, onCorrect }) {
	let next;
	if (canManage) next = canCorrect ? 'Unlock it to change it, or add a correction.' : 'Unlock it to change it.';
	else next = canCorrect ? 'A manager of this collection can unlock it, or you can add a correction.' : 'A manager of this collection can unlock it.';

	const buttons = [
		canManage ? <Button key="unlock" onClick={onUnlock}>Unlock…</Button> : null,
		canCorrect ? <Button key="correct" onClick={onCorrect}>Correct this record…</Button> : null,
	].filter(Boolean);

	return (
		<Alert
			className="item-form-page__alert record-lock-notice"
			type="warning"
			showIcon
			role="status"
			message={reason || 'This record is locked.'}
			description={(
				<>
					<p className="record-lock-notice__next">{next}</p>
					{buttons.length ? <div className="record-lock-notice__actions">{buttons}</div> : null}
				</>
			)}
		/>
	);
}
